/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCylinder = createReactComponent("outline", "cylinder", "IconCylinder", [["path", { "d": "M12 6m-7 0a7 3 0 1 0 14 0a7 3 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M5 6v12c0 1.657 3.134 3 7 3s7 -1.343 7 -3v-12", "key": "svg-1" }]]);

export { IconCylinder as default };
//# sourceMappingURL=IconCylinder.mjs.map
